import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { RbacActionEntity } from './rbac-action.entity';
import { UserEntity } from './user.entity';

@Index('_fk__rbac_action', ['fkRbacActionId'], {})
@Index('_userId', ['userId'], {})
@Entity('_rbac_action__user')
export class RbacActionUserEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__rbac_action__id',
		nullable: true,
		unsigned: true,
	})
	public fkRbacActionId!: number | null;

	@Column('varchar', { name: '_action', nullable: true, length: 255 })
	public action!: string | null;

	@Column('int', { name: '_userId', unsigned: true })
	public userId!: number;

	@ManyToOne(
		() => RbacActionEntity,
		(rbacAction) => rbacAction.rbacActionUsers,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk__rbac_action__id', referencedColumnName: 'id' }])
	public fkRbacAction!: RbacActionEntity;

	@ManyToOne(() => UserEntity, (user) => user.rbacActionUsers, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_userId', referencedColumnName: 'id' }])
	public user!: UserEntity;
}
